<template>
  <v-card class="base_info">
    <v-card-title :class="[fax_state_class, 'card_title']"><span class="headline">{{ send_state }}</span></v-card-title>
    <v-container fluid style="border-bottom: 1px solid lightgrey;">
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <div class="field_container mr-3" style="display: inline-block;">
            <span class="field_title" style="font-size: 20px; padding-bottom: 2px;">訂造 </span><v-icon>{{ info.tailor ? "check_box" : "check_box_outline_blank" }}</v-icon>
          </div>
          <div class="field_container" style="display: inline-block;">
            <span class="field_title" style="font-size: 20px; padding-bottom: 2px;">候電 </span><v-icon>{{ info.wait_for_call ? "check_box" : "check_box_outline_blank" }}</v-icon>
          </div>
        </v-flex>
        <v-flex xs6 sm2>
          <div class="field_container">
            <span class="field_title">單號： </span><p class="underline">{{ info.invoice_id }}</p>
          </div>
        </v-flex>
        <v-flex xs6 sm3>
          <div class="field_container">
            <span class="field_title">日期： </span><p class="underline">{{ info.date }}</p>
          </div>
        </v-flex>
        <v-flex xs12 sm7>
          <div class="field_container">
            <span class="field_title">分店： </span><p class="underline">{{ (info.parent_branch && `${info.parent_branch.name}`) || 'N/A' }}</p>
          </div>
        </v-flex>
        <v-flex xs12 sm4>
          <div class="field_container">
            <span class="field_title">姓氏： </span><p class="underline">{{ info.first_name }} {{ info.title }}</p>
          </div>
        </v-flex>
        <v-flex xs6 sm4>
          <div class="field_container">
            <span class="field_title">首選電話： </span><p class="underline"><a :href="`tel:${info.primary_telephone}`">{{ info.primary_telephone }}</a></p>
          </div>
        </v-flex>
        <v-flex xs6 sm4>
          <div class="field_container">
            <span class="field_title">後備電話： </span><p class="underline"><a v-if="info.second_telephone" :href="`tel:${info.second_telephone}`">{{ info.second_telephone }}</a><span v-else>N/A</span></p>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="field_container">
            <span class="field_title">地址： </span><p class="underline">{{ info.address }}</p>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-btn @click="showExtra = !showExtra" block flat color="grey">
            <v-icon :class="{'arrow': true, 'down': showExtra}">keyboard_arrow_down</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 :class="{'extra_info': true, 'shown': showExtra}" class="grey--text">
          <div class="field_container">
            <span class="field_title">開單時間： </span><span>{{ created_at }}</span>
          </div>
          <div class="field_container">
            <span class="field_title">上次更改時間： </span><span>{{ updated_at }}</span>
          </div>
          <div class="field_container">
            <span class="field_title">上次更改人： </span><span>{{ info.last_modified_by }}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <item-input :edit="false" :value="info.items" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid style="border-bottom: 1px solid lightgrey;">
      <v-layout row wrap>
        <v-flex xs12>
          <file-select-input :editable="false" v-model="info.files"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid style="border-bottom: 1px solid #b33127;">
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <div class="field_container">
            <span class="field_title">訂單備註： </span>
            <p class="underline" style="padding: 20px 10px;font-size: 15px;white-space: pre-wrap;" v-if="info.side_note">{{ info.side_note }}</p>
            <p v-else class="underline" style="padding: 20px 10px;font-size: 15px;color: rgba(200,200,200,1);">未有備註</p>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="field_container">
            <span class="field_title">公司備註： </span>
            <p class="underline" style="padding: 20px 10px;font-size: 15px;white-space: pre-wrap;" v-if="info.private_note">{{ info.private_note }}</p>
            <p v-else class="underline" style="padding: 20px 10px;font-size: 15px;color: rgba(200,200,200,1);">未有備註</p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid class="primary">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="field_container">
            <span class="field_title">總數： </span><p class="underline">$ {{ info.total_price }}</p>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="field_container">
            <span class="field_title">訂金： </span><p class="underline">$ {{ info.deposit }}</p>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="field_container">
            <span class="field_title">剩餘： </span><p class="underline">$ {{ info.balance }}</p>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="field_container">
            <span class="field_title">折扣： </span><p class="underline">$ {{ info.discount }}</p>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="field_container">
            <span class="field_title">付款方式： </span><p class="underline">{{ payment_method }}</p>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="field_container">
            <span class="field_title">來源： </span><p class="underline">{{ source }}</p>
          </div>
        </v-flex>
        <v-flex xs6></v-flex>
        <v-flex xs6>
          <div class="field_container">
            <span class="field_title">經手人： </span><p class="underline">{{ (info.salesman && `${info.salesman.first_name} ${info.salesman.last_name}`) || 'N/A' }}</p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

import FileSelectInput from './FileSelectInput'
import ItemInput from './ItemInput'

export default {
  name: 'invoice-sheet',
  components: { FileSelectInput, ItemInput },
  props: {
    info: {
      type: Object,
      default: () => { return {files: [],date: (() => {return new Date().toISOString().slice(0, 10)})(), branch: null, first_name: null, title: null, address: null, side_note: null, primary_telephone: null, second_telephone: null, items: [], deposit: 0, discount: 0} }
    },
    editFunc: Function
  },
  data() {
    return {
      showExtra: false
    }
  },
  computed:  {
    ...mapState({
      payment_methods: state => state.options.options.PAYMENT_METHODS || [],
      send_states: state => state.options.options.SEND_STATES || [],
      sources: state => state.options.options.SOURCE_TYPES || []
    }),
    source() {
      let find = this.sources.find(method => method[0] === this.info.source)
      return find && find[1]
    },
    payment_method() {
      let find = this.payment_methods.find(method => method[0] === this.info.payment_method)
      return find && find[1]
    },
    send_state() {
      let find = this.send_states.find(method => method[0] === this.info.send_state)
      return find && find[1]
    },
    fax_state_class() {
      const fax_state = {
        "A": 'not_faxed',
        "B": 'not_checked',
        "C": 'checking',
        "D": 'checked'
      }
      return fax_state[this.info.send_state]
    },
    created_at() {
      let date = new Date(this.info.created_at)
      return date.toLocaleString()
    },
    updated_at() {
      let date = new Date(this.info.updated_at)
      return date.toLocaleString()
    }
  }
}
</script>

<style scoped>

.card_title {
  color: white;
  font-weight: bold;
}
.card_title.not_faxed {
  background-color: #cc392e;
}
.card_title.not_checked {
  background-color: #f4af00;
}
.card_title.checking {
  background-color: #83c13a;
}

p {
  font-size: 14pt;
  margin-bottom: 5px;
  font-weight: 400;
}
p.underline {
  border-bottom: 1px solid rgb(200,200,200);
  padding-bottom: 2px;
}

.base_info .field_container {
  padding: 5px;
}
.base_info .field_title {
  font-weight: 200;
  font-size: 12pt;
}
.base_info .primary .field_container {
  color: white;
}
.base_info .primary .field_title {
  font-weight: 400;
}
.base_info .primary p.underline {
  border-color: white;
}

.extra_info {
  max-height: 0;
  overflow: hidden;
  transition: max-height .25s;
  transition-timing-function: ease-in-out;
}
.extra_info.shown {
  max-height: 300px;
}
.extra_info .field_container {
  padding: 0;
}
.extra_info .field_title {
  font-weight: 200;
  font-size: 13px;
}

.arrow {
  transition: transform .3s;
}
.arrow.down {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/InvoiceSheet.vue